<template>
  <div class="page-container batch-tool-native-anchor">
    <el-card class="mb-20">
      <app-filter
        :filter-list="table_filter"
        @search="search"
      />
    </el-card>
    <el-card>
      <div class="mb-20">
        <el-button size="mini" type="primary" @click="onAddTemplate">新增模板</el-button>
      </div>
      <app-table
        ref="table"
        :table-key="table_key"
        :tablep="table_params"
        :get-data="getAdvertiserSourceTemplateList"
      />
    </el-card>
    <!-- 新增模板/查看模板/创建资源 -->
    <el-dialog
      v-if="dialog_config.is_show"
      :title="dialog_config.title"
      :visible.sync="dialog_config.is_show"
      :before-close="dialog_config.cancel"
      width="800px"
    >
      <app-form
        v-if="dialog_config.is_show"
        ref="app-form"
        v-loading="dialog_config.is_loading"
        :form-data="dialog_config.form_config"
        default-label-width="110px"
        :is-reset-upon-cancel="false"
        @confirm="dialog_config.confirm"
        @cancel="dialog_config.cancel"
      >
        <template #custom="{ form_item, form_key }">
          <component
            :is="dialog_config.component_name"
            v-if="dialog_config.component_name"
            :page-config="page_config"
            :form-key="form_key"
            :form-item="form_item"
            :form-config="dialog_config.form_config"
          />
        </template>
      </app-form>
    </el-dialog>
    <!-- 未匹配到渠道包 -->
    <el-dialog
      v-if="channel_package_dialog_config.is_show"
      :title="channel_package_dialog_config.title"
      :visible.sync="channel_package_dialog_config.is_show"
      :before-close="channel_package_dialog_config.cancel"
      width="800px"
    >
      <channel-package
        v-if="channel_package_dialog_config.is_show"
        :page-config="page_config"
        :table-data="channel_package_dialog_config.table_data"
        :params="channel_package_dialog_config.submit_params"
      />
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="channel_package_dialog_config.is_show = false">上一步</el-button>
        <el-button type="primary" @click="channel_package_dialog_config.confirm">确定</el-button>
        <el-button @click="channel_package_dialog_config.cancel">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getPageConfig } from '@/views/auxiliary/batch-tool/source-template/config';
import { getMediasListApi } from '@/api/medias';
import {
  getAdvertiserSourceTemplateListApi,
  addAdvertiserSourceTemplateApi,
  getAdvertiserSourceTemplateDetailApi,
  editAdvertiserSourceTemplateApi,
  delAdvertiserSourceTemplateApi,
} from '@/api/tool/advertiser-source-template';
import { getUnmatchedChannelAliasesApi } from '@/api/tool/channel-package';
import { formDataAssign } from '@/tools/form';

export default {
  components: {
    'app-table': () => import('@/components/app-table'),
    'app-filter': () => import('@/components/app-filter'),
    'app-form': () => import('@/components/app-form'),
    'add-template': () => import('./components/add-template'),
    'create-source': () => import('./components/create-source'),
    'channel-package': () => import('./components/channel-package'),
  },
  data() {
    return {
      // 页面配置
      page_config: {},
      // 过滤项
      table_filter: require('./model/table-filter')(this),
      // 表头数据
      table_key: require('./model/table-key')(this),
      // 表格请求参数
      table_params: {
        page: 1,
        page_size: 10,
      },
      // 广告主账户选项
      advertiser_id_options: [],
      // 行编辑表单配置
      form_data_config: {
        name: {
          name: {
            label: '模板名称',
            type: 'input',
            props: {
              placeholder: '请输入模板名称',
            },
            value: '',
          },
        },
      },
      // 弹窗配置
      dialog_config: {
        is_show: false,
        is_loading: false,
        title: '新增',
        id: null,
        component_name: null, // 组件名称 - add-template：新建模板；view-template：查看模板；create-source：创建资源
        form_config: {},
        confirm: () => {},
        cancel: () => {},
      },
      // 渠道包弹窗配置
      channel_package_dialog_config: {
        is_show: false,
        is_loading: false,
        title: '安卓下载链接',
        submit_params: {},
        table_data: [],
        confirm: () => {},
        cancel: () => {},
      },
    };
  },
  watch: {
    '$route': {
      handler(to) {
        const { permissions } = to.meta || {};
        const page_config = getPageConfig(permissions);
        Object.assign(this.page_config, page_config);
      },
      immediate: true,
    },
  },
  async created() {
    this.advertiser_id_options = await this.getAdvertiserList();
  },
  methods: {
    /**
     * 搜索
     * @param {Object} params 查询参数
     * @returns {void}
     */
    search(params) {
      Object.assign(this.table_params, params);
      this.$refs.table.seekTable();
    },
    /**
     * 刷新列表
     * @returns {void}
     */
    refer() {
      this.$refs.table.refer();
    },
    /**
     * 新建模板
     * @returns {void}
     */
    onAddTemplate() {
      Object.assign(this.dialog_config, {
        is_show: true,
        title: '新建模板',
        component_name: 'add-template',
        form_config: require('./model/add-template-form-config.js')(this),
        confirm: (params) => {
          const { channel_interface, advertiser_source_type } = this.page_config;
          const payload = {
            channel_interface,
            advertiser_source_type,
            ...params,
          };
          addAdvertiserSourceTemplateApi(payload).then(({ message }) => {
            this.$message.success(message || '新建成功！');
            this.dialog_config.is_show = false;
            this.$refs.table.seekTable();
          });
        },
        cancel: () => {
          this.dialog_config.is_show = false;
        },
      });
      const { advertiser_id, advertiser_source_id } = this.dialog_config.form_config;
      advertiser_id.options = this.advertiser_id_options;
      advertiser_id.on = {
        change: async() => {
          advertiser_source_id.value = '';
          advertiser_source_id.params = { advertiser_id: advertiser_id.value };
          advertiser_source_id.options = await this.getAdvertiserSourceList(advertiser_source_id.params);
        },
      };

      const { model: { add_template_form_config: { form_config, setDifferentiatedFields } = {}}} = this.page_config;
      if (form_config) {
        const differentiated_fields = form_config(this);
        Object.assign(this.dialog_config.form_config, differentiated_fields);
      }
      setDifferentiatedFields?.(this.dialog_config);
    },
    /**
     * 创建资源
     * @param {Object} row 当前行数据
     * @returns {void}
     */
    onCreateSource(row) {
      const { name: row_name, id: advertiser_source_template_id } = row;
      Object.assign(this.dialog_config, {
        is_show: true,
        title: '创建内容',
        component_name: 'create-source',
        form_config: require('./model/create-source-form-config.js')(this),
        confirm: async(params) => {
          try {
            this.dialog_config.is_loading = true;
            const {
              advertiser_id,
              advertiser_source_name,
              delivery_platform_type,
              delivery_content_id,
              fusion__channel_code,
            } = params;
            const { channel_interface } = this.page_config;
            const payload = {
              channel_interface,
              advertiser_id,
              advertiser_source_template_id,
              advertiser_source_name,
              channel_aliases: fusion__channel_code.fusion__channel_codes[0].list.map(({ alias }) => alias),
              delivery_platform_type,
              delivery_content_id: delivery_content_id.result_map[advertiser_id].value.split('#')[0],
            };

            const { channel_aliases } = payload;
            const { unmatched_channel_aliases = [] } = await getUnmatchedChannelAliasesApi({ channel_interface, advertiser_id, channel_aliases, delivery_content_id: payload.delivery_content_id });
            if (unmatched_channel_aliases.length) {
              Object.assign(this.channel_package_dialog_config, {
                is_show: true,
                submit_params: payload,
                table_data: unmatched_channel_aliases.map(alias => ({
                  channel_alias: alias,
                  channel_package_name: '',
                  channel_package_id: '',
                })),
                confirm: async() => {
                  try {
                    this.channel_package_dialog_config.is_loading = true;
                    const { submit_params, table_data } = this.channel_package_dialog_config;
                    const is_valid = table_data.every(({ channel_package_id }) => !!channel_package_id);
                    if (!is_valid) {
                      this.$message.warning('请完整选择渠道包');
                      return;
                    }
                    const payload = {
                      ...submit_params,
                      specified_channel_packages: table_data.map(({ channel_alias, channel_package_id }) => ({ channel_alias, channel_package_id })),
                    };
                    const { message } = await this.batchCreate(payload);
                    this.$message.success(message || '创建成功！');
                    this.channel_package_dialog_config.is_show = false;
                    this.dialog_config.is_show = false;
                    this.$refs.table.seekTable();
                  } finally {
                    this.channel_package_dialog_config.is_loading = false;
                  }
                },
                cancel: () => {
                  this.$confirm('存在未提交的配置信息，确定关闭当前窗口吗', '提示').then(() => {
                    this.channel_package_dialog_config.is_show = false;
                    this.dialog_config.is_show = false;
                  });
                },
              });
              return;
            }

            const { message } = await this.batchCreate(payload);
            this.$message.success(message || '创建成功！');
            this.dialog_config.is_show = false;
            this.$refs.table.seekTable();
          } finally {
            this.dialog_config.is_loading = false;
          }
        },
        cancel: () => {
          this.$confirm('存在未提交的配置信息，确定关闭当前窗口吗', '提示').then(() => {
            this.dialog_config.is_show = false;
          });
        },
      });
      const { name, advertiser_id } = this.dialog_config.form_config;
      name.value = row_name;
      advertiser_id.options = this.advertiser_id_options;

      const { model: { create_source_form_config: { form_config, setDifferentiatedFields } = {}}} = this.page_config;
      if (form_config) {
        const differentiated_fields = form_config(this);
        Object.assign(this.dialog_config.form_config, differentiated_fields);
      }
      setDifferentiatedFields?.(this.dialog_config);
    },
    /**
     * 查看模板
     * @param {number} id 当前模板ID
     * @returns {void}
     */
    async onView(id) {
      try {
        const { components, model: { view_template_form_config } = {}, getViewTemplateDifferentiatedFields } = this.page_config;
        Object.assign(this.dialog_config, {
          is_show: true,
          is_loading: true,
          title: '查看模板',
          component_name: components?.view_template || null,
          form_config: view_template_form_config.form_config(this),
          confirm: () => {
            this.dialog_config.is_show = false;
          },
          cancel: () => {
            this.dialog_config.is_show = false;
          },
        });

        const { channel_interface } = this.page_config;
        const detail_data = await getAdvertiserSourceTemplateDetailApi({ channel_interface }, id);
        const {
          name,
          advertiser_id,
          advertiser_name,
          advertiser_source_id,
          advertiser_source_name,
        } = detail_data;
        const differentiated_fields = getViewTemplateDifferentiatedFields(detail_data);
        const payload = {
          name,
          advertiser: `${advertiser_name}（${advertiser_id}）`,
          advertiser_source: `${advertiser_source_name}|${advertiser_source_id}`,
          ...differentiated_fields,
        };
        formDataAssign(this.dialog_config.form_config, payload);
        view_template_form_config?.setDifferentiatedFields?.(this.dialog_config);
      } finally {
        this.dialog_config.is_loading = false;
      }
    },
    /**
     * 编辑
     * @param {Object} params 接口参数
     * @param {number} id 当前模板ID
     */
    onEdit(params, id) {
      const { channel_interface } = this.page_config;
      return new Promise((resolve, reject) => {
        editAdvertiserSourceTemplateApi({ channel_interface, ...params }, id).then(({ message }) => {
          this.$message.success(message || '更新成功');
          this.refer();
          resolve();
        }).catch(reject);
      });
    },
    /**
     * 删除
     * @param {Object} row 当前行数据
     * @returns {void}
     */
    onDel(row) {
      const { id, name } = row;
      const h = this.$createElement;
      const message_ele = h('div', { class: 'flex-col align-center' }, [
        h('div', { class: 'color-red mb-10' }, name),
        h('div', null, '是否删除当前已选中模板'),
      ]);
      this.$msgbox({
        title: '提示',
        message: message_ele,
        showCancelButton: true,
      }).then(() => {
        const { channel_interface } = this.page_config;
        delAdvertiserSourceTemplateApi({ channel_interface }, id).then(({ message }) => {
          this.$message.success(message || '删除成功');
          this.$refs.table.seekTable();
        });
      });
    },
    /**
     * 关闭表格所有的Popover
     * @returns {void}
     */
    closeAllTablePopover() {
      for (const key in this.$refs) {
        if (key.indexOf('table_el_popover_ref') !== -1) {
          this.$refs[key]?.doClose?.();
        }
      }
    },
    /**
     * 获取资源模板列表接口
     * @param {Object} params 过滤参数
     * @returns {Promise<Object>}
     */
    getAdvertiserSourceTemplateList(params) {
      const { channel_interface, advertiser_source_type } = this.page_config;
      const { name, ...rest } = params;
      return new Promise((resolve, reject) => {
        getAdvertiserSourceTemplateListApi({
          channel_interface,
          filtering: {
            advertiser_source_type,
            ...(name && { name }),
          },
          ...rest,
        }).then(resolve).catch(reject);
      });
    },
    /**
     * 获取广告主账号列表
     * @returns {Promise<Object[]>}
     */
    getAdvertiserList() {
      const { channel_interface } = this.page_config;
      return new Promise((resolve, reject) => {
        getMediasListApi({
          type: channel_interface,
          is_list: true,
        }).then(res => {
          const result = res.list.map(({ advertiser_id, advertiser_name, note }) => {
            return {
              label: `${advertiser_id}（${advertiser_name}）${note ? ' - ' + note : ''}`,
              value: advertiser_id,
            };
          });
          resolve(result);
        }).catch(reject);
      });
    },
    /**
     * 获取模板来源列表
     * @param {Object} params 过滤参数
     * @returns {Promise<Object>}
     */
    getAdvertiserSourceList(params) {
      const { channel_interface, getAdvertiserSourceApi } = this.page_config;
      return new Promise((resolve, reject) => {
        getAdvertiserSourceApi({
          channel_interface,
          ...params,
        }).then(({ list = [] }) => {
          const result = list.map(({ id, name }) => ({ label: name, value: id }));
          resolve(result);
        }).catch(reject);
      });
    },
    /**
     * 创建内容接口
     * @param {Object} params 过滤参数
     * @returns {Promise<Object>}
     */
    batchCreate(params) {
      const { batchCreateApi } = this.page_config;
      return batchCreateApi(params);
    },
  },
};
</script>

<style lang="scss">
.batch-tool-native-anchor {
  .pt-0 {
    padding-top: 0 !important;
  }
  .children-form-widget {
    padding-top: 9px !important;
  }
}
</style>

